import { Reply, X } from "lucide-react";

/** Texte court pour citation / bandeau réponse. */
export function chatReplySnippet(
  body: string,
  opts?: { hasImage?: boolean; hasFile?: boolean; hasVoice?: boolean }
): string {
  const t = body.replace(/\s+/g, " ").trim();
  if (!t) {
    if (opts?.hasVoice) return "Message vocal";
    if (opts?.hasImage) return "Photo";
    if (opts?.hasFile) return "Fichier";
    return "Message";
  }
  if (/^message vocal$/i.test(t)) return "Message vocal";
  // URL image / GIF seule
  if (/^https?:\/\/\S+\.(gif|png|jpe?g|webp)(\?\S*)?$/i.test(t) || t.includes("giphy.com") || t.includes("tenor.com")) {
    return "GIF / Photo";
  }
  if (t.length <= 72) return t;
  return `${t.slice(0, 70)}…`;
}

type ReplyQuoteProps = {
  author: string;
  snippet: string;
  mine?: boolean;
  onClick?: () => void;
};

/** Citation dans une bulle (style WhatsApp / Messenger). */
export function ChatReplyQuote({ author, snippet, mine, onClick }: ReplyQuoteProps) {
  return (
    <button
      type="button"
      className={`chat-reply-quote mb-1 flex w-full max-w-full flex-col gap-0.5 rounded-lg border-l-[3px] px-2 py-1 text-left ${
        mine ? "chat-reply-quote--mine" : "chat-reply-quote--other"
      }`}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      <span className="truncate text-[10px] font-semibold leading-tight">{author}</span>
      <span className="line-clamp-2 text-[11px] leading-snug opacity-90">{snippet}</span>
    </button>
  );
}

type ReplyComposerBarProps = {
  author: string;
  snippet: string;
  onCancel: () => void;
};

/** Bandeau au-dessus du composer. */
export function ChatReplyComposerBar({ author, snippet, onCancel }: ReplyComposerBarProps) {
  return (
    <div className="chat-reply-composer flex items-stretch gap-2 border-t border-[var(--chat-border)] bg-[var(--chat-surface-elevated)] px-2.5 py-1.5">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <Reply className="size-4 shrink-0 text-[var(--chat-accent-strong)]" aria-hidden />
        <div className="min-w-0 flex-1 border-l-[3px] border-[var(--chat-accent)] pl-2">
          <p className="truncate text-[11px] font-semibold text-[var(--chat-accent-strong)]">
            Réponse à {author}
          </p>
          <p className="truncate text-[11px] text-[var(--chat-muted)]">{snippet}</p>
        </div>
      </div>
      <button
        type="button"
        className="shrink-0 rounded-lg p-1.5 text-[var(--chat-muted)] hover:bg-[var(--chat-surface)] hover:text-[var(--chat-text)]"
        aria-label="Annuler la réponse"
        onClick={onCancel}
      >
        <X className="size-4" />
      </button>
    </div>
  );
}
